import { descend, prop, sort } from "ramda";

export default (auditPeriods) => sort(descend(prop("year")), auditPeriods);
